export default "__VITE_ASSET__OPRbrDnz__"